import RestApiModel from "@/api/Model/RestApiModel";
import api from '@/api';

class User extends RestApiModel {

  static getResourceEndpoint() {
    return '/users';
  }

  static resetPassword(id) {
    return api.get(`${this.getResourceEndpoint()}/${id}/reset-password`);
  }

  static updateAddresses(id, addresses) {
    return api.post(`${this.getResourceEndpoint()}/${id}/update-addresses`, { addresses });
  }

  static updateAddress(userId, addressId, address) {
    return api.patch(`${this.getResourceEndpoint()}/${userId}/address/${addressId}`, address);
  }

  static createAddress(userId, address) {
    return api.post(`${this.getResourceEndpoint()}/${userId}/create-address`, address);
  }

  static getAddress(userId, addressId) {
    return api.get(`${this.getResourceEndpoint()}/${userId}/address/${addressId}`);
  }

  static getEntity() {
    return api.get('user/entity');
  }

  static setPrimary(userId, addressId) {
    return api.patch(`${this.getResourceEndpoint()}/${userId}/address/${addressId}/set-as-primary`);
  }

  /**
   * @param id
   * @param isEnabled
   * @returns {*}
   */
  static enable(id, isEnabled) {
    return api.patch(`${this.getResourceIdEndpoint(id)}/enable`, {isEnabled});
  }

  static listWithExternalEdentity() {
    return api.get(`${this.getResourceEndpoint()}/with-external-identity`);
  }
}

export default User;
